import React, { useState } from 'react'
import { Form, Input, Button, notification } from 'antd';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import axios from 'axios';
import key from '../../../key';
import { useCookies } from 'react-cookie';

const ContactDetails = () => {
    const [form] = Form.useForm();
    const { user } = useSelector(state => state.user);
    const [isWhatsAppEdit, setIsWhatsAppEdit] = useState(false);
    const [whatsapp, setWhatsapp] = useState(user?.whatsApp);
    //eslint-disable-next-line
    const [cookies, setCookies, removeCookies] = useCookies(['x-auth-token']);

    const handleChangeWhatsapp = async (values) => {
        try {
            const res = await axios.put(`${key}/api/user/change-whatsapp`, { whatsApp: values.whatsApp }, {
                headers: {
                    'x-auth-token': cookies['x-auth-token']
                }
            });
            if (res.data.success) {
                notification.success({ message: "Whatsapp Number changed Successfully" })
                setWhatsapp(values.whatsApp)
                setIsWhatsAppEdit(false);
                form.resetFields();
            } else {
                notification.error({ message: "Can't change right now try again later!" })
            }
        } catch (error) {
            notification.error({ message: error.response.data.msg })
        }
    }

    const cancelChange = () => {
        setIsWhatsAppEdit(false);
    }

    return (
        <div>
            <div className='tabContent'>
                <div className="customCard">
                    <div className="customCardTitle backgroundGrey">
                        <div>Phone</div>
                    </div>
                    <div className="customCardBody backgroundLight row">
                        <div className="col-md-4">Phone</div>
                        <div className="col-md-4">
                            <div>: {user?.mobile}</div>
                        </div>
                    </div>
                </div>
                <div className="customCard">
                    <div className="customCardTitle backgroundGrey">
                        <div>Whatsapp Number</div>
                        <Link onClick={() => setIsWhatsAppEdit(true)}>Edit</Link>
                    </div>
                    <div className="customCardBody backgroundLight row">
                        <div className="col-md-4">WhatsApp Number</div>
                        <div className="col-md-4">
                            {isWhatsAppEdit ? (
                                <Form
                                    form={form}
                                    name="whatsAppChange"
                                    onFinish={handleChangeWhatsapp}
                                    scrollToFirstError
                                >
                                    <Form.Item
                                        name="whatsApp"
                                        rules={[
                                            { required: true, message: 'Please input your whatsapp number!' },
                                        ]}
                                    >
                                        <Input
                                            placeholder="whatsapp number"
                                        />
                                    </Form.Item>
                                    <Form.Item>
                                        <Button type="primary" htmlType="submit">
                                            Save
                                        </Button>
                                        <Button style={{ marginLeft: 20 }} onClick={cancelChange}>
                                            Cancle
                                        </Button>
                                    </Form.Item>
                                </Form>
                            ) : <div>: {whatsapp}</div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactDetails
